import script from "./DragZoom.vue?vue&type=script&lang=ts&setup=true"
export * from "./DragZoom.vue?vue&type=script&lang=ts&setup=true"

import "./DragZoom.vue?vue&type=style&index=0&id=171d5e5b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171d5e5b"]])

export default __exports__